exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".start--grid--oSuDOs9l {\r\n  width: 100%;\r\n}", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/views/start/start.css"],"names":[],"mappings":"AAAA;EACE,YAAY;CACb","file":"start.css","sourcesContent":[".grid {\r\n  width: 100%;\r\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"grid": "start--grid--oSuDOs9l"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/views/start/start.css
// module id = 447
// module chunks = 0